import { organizations, adminUnits, contactPersons } from './itemsFixtureData';

/**
 * DL-65674 (epic — dl-58221 part 3, "cursor pagination integrity, nulls & ties"), story DL-65680 /
 * Testmo #753716 — the one case not covered by this epic's first pass (see that PR's own note:
 * "deliberately deferred, not blocked"). Split into its own file rather than appended to
 * `itemsSortingCursorProbeFixtureData.ts` to avoid touching that file while it may still be under
 * concurrent edit on this same branch.
 *
 * Mirrors that file's conventions: 210 real, persisted `itemsData` rows (not an `apiTransform` GET
 * override, which would bypass `sortItems`), isolated via `?search=zzCursorProbeDesc`, with
 * distinct, zero-padded `description` values so lexicographic order matches insertion order and
 * the non-empty block straddles the page-1/page-2 boundary at index 100 (`perPage = 100` in
 * `items.ts`) — the same boundary-spanning shape the BC/SC/CF groups use.
 */

let probeId = 958000;

const descriptionProbeRow = (index: number) => ({
  id: probeId++,
  name: `zzCursorProbeDesc ${String(index).padStart(3, '0')}`,
  userDefinedId: `CUR-DESC-${index}`,
  description: `zzCursorProbeDesc Value ${String(index).padStart(3, '0')}`,
  brand: { id: 9101, name: 'CursorProbe Brand' },
  organization: organizations[0],
  supplier: { id: 9102, name: 'CursorProbe Supplier' },
  companyContactPerson: contactPersons[0],
  supplierContactPerson: null,
  adminUnit: adminUnits[0],
  logo: null,
  isActive: true,
  suppliedBy: null,
  readyForExport: false,
  updatedAfterLastExport: false,
  lastUpdated: '2026-03-15T09:00:00',
  deadline: null,
  etd: null,
  erpItemId: null,
  defaultQty: 7,
  nameGeneratorExtraText: null,
  physicalReferenceNumber: null,
  categories: [],
  customFields: [] as never[],
});

export const itemsSortingCursorDescriptionProbeRows = Array.from({ length: 210 }, (_, i) =>
  descriptionProbeRow(i)
);
